import React, { useState } from 'react';
import { Divider } from '@material-ui/core';

import Form from './Form';
import { formatMoney } from '../../lib/utils';
import { CustomSlider, CustomSliderPlazo } from './CustomSlider';
import { investorInversionMarks, plazoMarks } from './marksSlider';
import { ValueLabelComponent, ValueLabelPlazoComponent } from './ValueLabel';

const YEAR_DAYS = 360;

const Investor = () => {
  const [monto, setMonto] = useState(50000);
  const [plazo, setPlazo] = useState(60);
  const [tasa, setTasa] = useState(24);

  const rendimiento = monto * (tasa / 100) * (plazo / YEAR_DAYS);

  return (
    <div style={{maxHeight: '500px', top: '-30px'}} className="w-full md:w-1/2 relative mt-8 md:mt-0">
      <div className="p-4 mx-6 relative shadow-2xl bg-white md:max-w-lg md:mx-auto">
        <div className="pt-4">
          <h2 className="uppercase mb-6 text-gray-700">Tu Inversión</h2>
          <div className="px-8">
            <CustomSlider
              ValueLabelComponent={ValueLabelComponent}
              marks={investorInversionMarks}
              aria-label="simulador monto inversionista"
              onChange={(_, value: number) => setMonto(value)}
              defaultValue={50000}
              step={10000}
              max={500000}
            />
          </div>
        </div>
        <div className="py-4">
          <h2 className="uppercase mb-6 text-gray-700">Plazo</h2>
          <div className="px-8">
            <CustomSliderPlazo
              ValueLabelComponent={ValueLabelPlazoComponent}
              marks={plazoMarks}
              aria-label="simulador plazo inversionista"
              onChange={(_, value: number) => setPlazo(value)}
              defaultValue={60}
              min={30}
              max={120}
            />
          </div>
        </div>
        <Divider />
        <div className="py-4">
          <h2 className="uppercase text-gray-700">¿Qué tipo de inversionista eres?</h2>
          <div className="flex flex-col mt-6 md:flex-row">
            <Form onSelectPercentage={(tasa: number) => setTasa(tasa)} />
          </div>
          <p className="text-gray-700 text-xs mt-8">* Tasas de interés promedio + IVA</p>
        </div>
        <Divider />
        <div className="py-4 flex flex-col justify-between items-center md:flex-row">
          <h2 className="text-gray-700 uppercase">Tu rendimiento sería: </h2>
          <span className="text-gray-700 text-xl font-bold">${formatMoney(String(rendimiento), 2)} MXN</span>
        </div>
        <a className="block text-xl text-center text-white py-4 shadow-xl tracking-wide left-0 right-0 w-full absolute bg-green-200" href="#contacto">Solicitar más información</a>
      </div>
    </div>
  );
}

export default Investor;
